import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { createResourceVideo, showToast } from "../Utils/utils";

const CreateVideo = () => {
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false);
    const [title, setTitle] = useState("");
    const [coverFile, setCoverFile] = useState(null);
    const [videoFile, setVideoFile] = useState(null);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const onCoverChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setCoverFile(file)
    };
    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setVideoFile(file)
    }

    const isFormValid =
        title.trim() &&
        videoFile

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const isHttpsUrl = (url) => {
        try {
            const parsed = new URL(url);
            return parsed.protocol === "https:";
        } catch {
            return false;
        }
    };

    const isYoutubeUrl = (url) => {
        return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url);
    };

    const isVideoFileUrl = (url) => {
        return /\.(mp4|webm|ogg|m3u8)$/i.test(url);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!(videoFile instanceof File)) {

            if (!isValidUrl(videoFile)) {
                showToast("Please enter a valid URL", "error");
                return;
            }
            if (!isHttpsUrl(videoFile)) {
                showToast("Only secure HTTPS video URLs are allowed", "error");
                return;
            }
            if (!isYoutubeUrl(videoFile) && !isVideoFileUrl(videoFile)) {
                showToast(
                    "Only YouTube links or direct video URLs are allowed",
                    "error"
                );
                return;
            }
        }
        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("resource_id", id);
            formData.append("title", title);
            formData.append("cover", coverFile);
            formData.append(videoFile instanceof File ? "file" : "video_url", videoFile);

            const response = await createResourceVideo({ formData });
            if (response.status == 200) {
                showToast("Video added successfully", "success")
                setTimeout(() => {
                    window.location.href = `/manage-resource/${id}`;
                }, [1000])
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.log(error, "error...");
            setLoading(false)
            showToast(error.message, "error")
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`/manage-resource/${id}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Create Video</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <form className="card mb-4" onSubmit={(e) => handleSubmit(e)}>
                                            <div className="card-body">

                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input
                                                        className="form-control"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>Cover Image</label>
                                                    <div className="d-flex gap-4">
                                                        <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                                                            Browse
                                                            <input hidden type="file" accept="image/*" onChange={onCoverChange} />
                                                        </label>
                                                        {coverFile && (
                                                            <>
                                                                <div className="mt-2">
                                                                    {coverFile?.name}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>Video File</label>
                                                    <div className="d-flex gap-4">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Paste video URL here or Uplaod file"
                                                            value={videoFile instanceof File ? videoFile.name : videoFile}
                                                            onChange={(e) => setVideoFile(e.target.value)}
                                                        />

                                                        {/* Browse button */}
                                                        <label className="btn btn-outline-primary mb-0">
                                                            Browse
                                                            <input
                                                                type="file"
                                                                accept="video/*"
                                                                hidden
                                                                onChange={onFileChange}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn cta-btn mt-4" disabled={loading || !isFormValid}>
                                                    Create
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default CreateVideo;
